/* eslint-disable import/no-anonymous-default-export*/
import { GET_LOANS, GET_SETTLEMENTS } from "../actions/types";

const initialState = {
  isLoading: true,
  loans: [],
  settlements: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_LOANS:
      return {
        ...state,
        loans: action.payload,
      };

    case GET_SETTLEMENTS:
      return {
        ...state,
        settlements: action.payload,
      };

    default:
      return state;
  }
}
